import { RichTextStyleWrapper } from "blocks/components";
import { styled } from "lib/theme";

export const ProjectAuthWrapper = styled.div`
  min-height: "100vh";
  background-color: ${({ theme }) => theme.app.colors.pageBackground};
`;

export const Content = styled.div`
  max-width: 400px;
  margin: 30px auto;
`;

export const RichText = styled(RichTextStyleWrapper)`
  text-align: center;
`;
